import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-image-renderer',
  templateUrl: './image-renderer.component.html',
  styleUrls: ['./image-renderer.component.scss']
})
export class ImageRendererComponent implements ICellRendererAngularComp{
  params: any;
  displayImage:any;
  constructor(){
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.displayImage = this.params?.data?.photoUrl;
  }

  refresh(): boolean {
    this.displayImage = this.params?.data?.photoUrl;
    return true;
  }
  
}
